const FETCH_RESOURCE_REQUEST = 'FETCH_RESOURCE_REQUEST'
const FETCH_RESOURCE_SUCCESS = 'FETCH_RESOURCE_SUCCESS'
const FETCH_RESOURCE_FAILURE = 'FETCH_RESOURCE_FAILURE'

export { FETCH_RESOURCE_REQUEST, FETCH_RESOURCE_SUCCESS, FETCH_RESOURCE_FAILURE }
